// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { CashRegisterReceiptFragment } from '../../fragments/generated/cash-register-receipt.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type BuildCashRegisterReceiptQueryVariables = Types.Exact<{
  buildCashRegisterReceiptRequestDTO: Types.BuildCashRegisterReceiptRequestDtoInput;
}>;


export type BuildCashRegisterReceiptQueryResult = { __typename?: 'Query', buildCashRegisterReceipt: { __typename?: 'CashRegisterReceiptDTO', invoiceHolder: { __typename?: 'CashRegisterInvoiceHolderDTO', fiscalCode: string | null, lines: Array<string>, lotteryCode: string | null } | null, items: Array<{ __typename?: 'CashRegisterItemDTO', amount: number | null, description: string | null, note: string | null, type: Types.CashRegisterItemTypeEnumDto, department: { __typename?: 'DepartmentDTO', atecoCodeId: number | null, cashRegisterCode: string | null, description: string, id: number, sellGoods: boolean, vatRateId: number, atecoCode: { __typename?: 'AtecoCodeDTO', cashRegisterCode: string | null, code: string, description: string, id: number, ownerId: number } | null, vatRate: { __typename?: 'VatRateDTO', atecoCodeId: number | null, cashRegisterCode: string | null, description: string, id: number, ownerId: number, rate: number, referenceOnZeroVat: string | null, naturaTypeOnZeroVat: Types.NaturaTypeEnumDto | null, atecoCode: { __typename?: 'AtecoCodeDTO', cashRegisterCode: string | null, code: string, description: string, id: number, ownerId: number } | null } } | null } | null> | null, payments: Array<{ __typename?: 'CashRegisterPaymentDTO', amount: number | null, description: string | null, type: Types.CashRegisterPaymentTypeEnumDto } | null> | null } | null };

export const BuildCashRegisterReceiptGql = gql`
    query BuildCashRegisterReceipt($buildCashRegisterReceiptRequestDTO: BuildCashRegisterReceiptRequestDTOInput!) {
  buildCashRegisterReceipt(
    buildCashRegisterReceiptRequestDTO: $buildCashRegisterReceiptRequestDTO
  ) {
    ...CashRegisterReceipt
  }
}
    ${CashRegisterReceiptFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BuildCashRegisterReceiptInjectable extends Apollo.Query<BuildCashRegisterReceiptQueryResult, BuildCashRegisterReceiptQueryVariables> {
    override document = BuildCashRegisterReceiptGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */